<template>
  <div>
    <b-card no-body>
      <b-card-body class="border border-dashed border-top-0 border-end-0 border-start-0 mb-3">
        <b-form>
          <b-row class="g-3">
            <b-col>
              <div class="search-box">
                <input type="text" class="form-control search" v-model="filter_value.keyword"
                       :placeholder="`${$t('page.user.name')}/${$t('page.work-order.contact-phone')}/${$t('page.email')}`" />
                <i class="ri-search-line search-icon"></i>
              </div>
            </b-col>
            <b-col cols="12" md="auto">
              <div class="align-content-end">
                <b-button type="button" variant="success" @click="doFilter" class="me-3">
                  <i class="ri-equalizer-fill me-1 align-bottom"></i>
                  {{ $t('page.filter') }}
                </b-button>
<!--        这里不添加工程师，到企业账户或用户管理下添加工程师角色的用户        -->
<!--                <b-button type="button" variant="primary" class="add-btn" @click="add">-->
<!--                  <i class="ri-add-line align-bottom me-1"></i> 添加-->
<!--                </b-button>-->
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-body class="pt-0 flex-grow-1">
        <div>
          <div class="table-responsive table-card mb-1">
            <table class="table table-nowrap align-middle">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <template v-for="(item, index) in tableHeaders" :key="index">
                  <th v-show="item.visible" :class="item.name === 'label' ? 'td-100' : ''">{{ item.label }}</th>
                </template>
<!--                <th>-->
<!--                  操作-->
<!--                </th>-->
              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr v-if="adding">
                <td>
                  <input type="text" class="form-control" :class="v$.addItem.name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('base.required')" v-model="addItem.name" required />
                </td>
                <td>
                  <input type="text" class="form-control" :class="v$.addItem.tel.$errors.length ? 'is-invalid' : ''" :placeholder="$t('base.required')" v-model="addItem.tel" required />
                </td>
                <td>
                  <input type="text" class="form-control" :class="v$.addItem.email.$errors.length ? 'is-invalid' : ''" :placeholder="$t('base.required')" :title="v$.addItem.email.$errors.length ? this.$t('page.wrongEmailFormat') : ''" v-model="addItem.email" required />
                </td>
                <td>
                  <input type="text" class="form-control" placeholder="" v-model="addItem.department" />
                </td>
                <td>
                  <input type="text" class="form-control" placeholder="" v-model="addItem.position" />
                </td>
                <td style="width: 100px;">
                  <Multiselect
                      v-model="addItem.label"
                      mode="tags"
                      :close-on-select="false"
                      :searchable="true"
                      :filter-results="false"
                      :create-option="true"
                      :options="[]"
                  />
                </td>
                <td>
                  <i class="ri-checkbox-circle-line me-3 text-primary fs-2 cursor-pointer" @click="addSave"></i>
                  <i class="ri-close-circle-line me-3 text-danger fs-2 cursor-pointer" @click="adding = false"></i>
                </td>

              </tr>
              <tr v-for="(item, index) in dataList" :key="index">
                <template v-for="(titleItem, titleIdx) in tableHeaders" :key="titleIdx">
                  <td v-show="titleItem.visible">
                    <!--        显示            -->
                    <template v-if="item.id != editId">
                      <div v-if="titleItem.name === 'name'" class="d-flex align-items-center">
                        <img v-if="item['logo']" class="rounded-circle avatar-xs me-2" alt="logo" :src="item['logo']" />
                        <div v-else class="avatar-xs me-2">
                          <div class="avatar-title rounded-circle bg-soft-info text-info">
                            {{ item['name'][0] }}
                          </div>
                        </div>
                        {{ item[titleItem.name] }}
                      </div>
                      <span v-else-if="titleItem.name == 'label'" v-for="(tag, tagIndex) in getLabels(item[titleItem.name])" :key="tagIndex" class="badge badge-soft-primary me-1">
                        {{ tag }}
                      </span>
                      <span v-else>{{ item[titleItem.name] }}</span>
                    </template>
                    <!--         编辑           -->
                    <template v-else>
                      <Multiselect
                          v-if="titleItem.name == 'label'"
                          v-model="editItem[titleItem.name]"
                          mode="tags"
                          :close-on-select="false"
                          :searchable="true"
                          :filter-results="false"
                          :create-option="true"
                          :options="editItem[titleItem.name]"
                      />
                      <input v-else-if="titleItem.name == 'name'" type="text" class="form-control" :class="v$.editItem.name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('base.required')" v-model="editItem.name" required />
                      <input v-else-if="titleItem.name == 'tel'" type="text" class="form-control" :class="v$.editItem.tel.$errors.length ? 'is-invalid' : ''" :placeholder="$t('base.required')" v-model="editItem.tel" required />
                      <input v-else-if="titleItem.name == 'email'" type="text" class="form-control" :class="v$.editItem.email.$errors.length ? 'is-invalid' : ''" :placeholder="$t('base.required')" :title="v$.editItem.email.$errors.length ? $t('page.wrongEmailFormat') : ''" v-model="editItem.email" required />
                      <input v-else type="text" class="form-control" placeholder="" v-model="editItem[titleItem.name]" />
                    </template>
                  </td>
                </template>
<!--                这里隐藏操作列，工程师的操作不在这里做  -->
<!--                <td v-if="editId != item.id">-->
<!--                  <i class="ri-edit-2-line fs-3 text-primary me-3 cursor-pointer" @click="edit(item, index)"></i>-->
<!--                  <i class="ri-delete-bin-line fs-3 text-primary me-3 cursor-pointer" @click="del(item)"></i>-->
<!--                </td>-->
<!--                <td v-else>-->
<!--                  <i class="ri-checkbox-circle-line me-3 text-primary fs-2 cursor-pointer" @click="editSave"></i>-->
<!--                  <i class="ri-close-circle-line me-3 text-danger fs-2 cursor-pointer" @click="editCancel"></i>-->
<!--                </td>-->
              </tr>
              </tbody>
            </table>
            <table-loading :table-loading="tableLoading" :table-loaded="tableLoaded" :count="count"></table-loading>
          </div>
        </div>
        <Pagination
            v-if="tab_info_length"
            v-model:page="page"
            v-model:perPage="perPage"
            :pages="pages"
            :prePageOption="prePageOption"
            :tab_info_length="tab_info_length"
            @update:page="pageChange"
            @update:perPage="pageSizeChange"
            class="me-5 my-3"
        ></Pagination>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import _ from "lodash";
import {
  getCompanyEngineers,
  postCompanyEngineer,
  patchCompanyEngineer,
  deleteCompanyEngineer,
} from "@/service"
import tableLoading from "@/views/widgets/table-loading";
import {successMsg, alertComfirm} from "@/helpers/swal";
import {useVuelidate} from "@vuelidate/core";
import {email, required} from "@vuelidate/validators";
export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    tableLoading,
  },
  data () {
    return {
      companyId: null,
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      tableHeaders: [
        {
          name: 'name',
          label: this.$t('page.user.name'),
          visible: true
        },
        {
          name: 'tel',
          label: this.$t('page.user.contact number'),
          visible: true
        },
        {
          name: 'email',
          label: this.$t('page.user.email'),
          visible: true
        },
        {
          name: 'department',
          label: this.$t('page.user.department'),
          visible: true
        },
        {
          name: 'position',
          label: this.$t('page.user.position'),
          visible: true
        },
        // {
        //   name: 'label',
        //   label: '标签',
        //   visible: true
        // },
      ],
      tableLoading: false,
      tableLoaded: false,
      dataList: [],
      count: 0,
      filters: {
        page: 1,
        page_size: 10,
        company: null,
      },
      filter_value: {
        keyword: '',
      },
      adding: false,
      editId: null,
      editIndex: null,
      addItem: {
        name: null,
        tel: null,
        email: null,
        department: null,
        position: null,
        label: [],
        logo: null,
        company: null
      },
      editItem: {},
    }
  },
  validations: {
    addItem: {
      name: { required },
      tel: { required },
      email: { required, email },
    },
    editItem: {
      name: { required },
      tel: { required },
      email: { required, email },
    },
  },
  mounted() {
    this.companyId = this.$route.params.id
    this._getFirstPage()
  },
  methods: {
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 新建
    add() {
      for (let p in this.addItem) {
        if (p === 'label') {
          this.addItem[p] = []
        } else {
          this.addItem[p] = null
        }
      }
      this.adding = true
    },
    // 保存添加
    addSave() {
      this.v$.addItem.$touch()
      if (this.v$.addItem.$invalid) {
        return
      }
      const params = _.cloneDeep(this.addItem)
      params.company = this.companyId
      if (params.label.length) {
        params.label = params.label.join(',')
      } else {
        params.label = null
      }
      postCompanyEngineer(params).then(() => {
        successMsg(this.$t('base.add_success'))
        this._getFirstPage()
        this.adding = false
      }).catch(err => {
        console.log(err)
      })
    },
    // 编辑
    edit(item, index) {
      this.editItem = Object.assign({}, item)
      if (this.editItem.label) {
        this.editItem.label = this.editItem.label.split(',')
      } else {
        this.editItem.label = []
      }
      this.editId = item.id
      this.editIndex = index
    },
    // 取消编辑
    editCancel() {
      this.editItem = {}
      this.editId = null
      this.editIndex = null
    },
    // 保存编辑
    editSave() {
      this.v$.editItem.$touch()
      if (this.v$.editItem.$invalid) {
        return
      }
      const params = _.cloneDeep(this.editItem)
      if (params.label.length) {
        params.label = params.label.join(',')
      } else {
        params.label = null
      }
      patchCompanyEngineer(params).then(res => {
        successMsg(this.$t('base.modified_successfully'))
        this.dataList[this.editIndex] = res.payload
        this.editId = null
        this.editIndex = null
        this.editItem = {}
      }).catch(err => {
        console.log(err)
      })
    },
    // 删除
    del(item) {
      alertComfirm().then(res => {
        if (res) {
          deleteCompanyEngineer(item.id).then(() => {
            successMsg(this.$t('base.delete_success'))
            this._getFirstPage()
          })
        }
      })
    },
    getLabels(label) {
      if (!label) {
        return []
      }
      return label.split(',')
    },
    // 筛选
    doFilter () {
      this.orders = []
      const search = {
        keyword: null,
      }
      if (this.filter_value.keyword) {
        search['keyword'] = this.filter_value.keyword
      }
      this.filters = _.assign(this.filters, search)
      this._getFirstPage()
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val
      this._getList()
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val
      this._getFirstPage()
    },
    // 获取数据
    _getFirstPage() {
      this.filters.page = 1;
      this._getList()
    },
    _getList() {
      this.filters.page_size = this.perPage
      this.filters.company = this.companyId
      this.tableLoading = true
      this.tableLoaded = false
      getCompanyEngineers(this.filters).then(res => {
        this.tableLoading = false
        this.tableLoaded = true
        this.dataList = res.payload.results
        this.count = res.payload.count
        this.setPages()
      }).catch(err => {
        console.log(err)
      })
    },
  }
}
</script>
<style scoped>
.td-100 {
  min-width: 100px;
}
</style>
